<template>
  <div class="row card animated zoomIn">
    <div class="col s12 m6">
      <h5>iRecharge Perks</h5>
      <p class="text-justify">
        Save money and time by centralizing your business operations with this
        unique corporate solution. Pay for services and recharge all your
        official mobile lines for less in one swift click. This package is best
        suited to companies and multi-nationals because we understand that the
        core of most business operations includes paying bills for airtime,
        internet, power and also making subscription payments for cable TV.
        <strong>iRecharge Corporate</strong> provides a value added service to
        such clients and enables them get amazing discounts on major recurrent
        operations cost.
      </p>
      <h5>Benefits</h5>
      <ul>
        <li>
          Get discounts on major recurrent operations cost and still enjoy
          convenience.<em></em>
        </li>
        <li>
          Schedule airtime and data top ups for your staff lines or CUG’s.
        </li>
        <li>Pay your company’s power bills.</li>
        <li>Pay your internet and cable tv subscription.</li>
        <li>Design rewards and promotions for your staff and clients.</li>
        <li>Recharge multiple lines instantly with one click.</li>
        <li>Supports Pre Paid and Post Paid Lines</li>
        <li>
          Can be accessed from any internet enabled computer, tablet or
          smartphone.
        </li>
        <li>Fast and reliable</li>
        <li>Multiple services form one platform</li>
        <li>Secure and verified platform</li>
      </ul>
      <p class="text-justify">
        Here are a few examples of how you can take advantage of iRecharge
        Perks, There is always a reward for the consumer in terms of benefits
        and the business in terms of increased sales. <br />
        Promotions can be directed at the customer, sales staff or distribution
        channel members and are therefore suitable for all solutions. <br />
        Your <strong>hotel</strong> can use iRecharge perks to reward loyal
        customers or as a way of retaining new customers. Hotel management can
        automatically gift guests airtime at check in. The value of the airtime
        will be defined by the hotel and can be a fixed amount or determined by
        the customers profile or bill. You can also increase your patronage for
        specific periods by offering free airtime top ups to all guests that
        check in between a particular date range. <br />
        <strong>Restaurants</strong> can reward their most consistent customers
        at the end of every month. For instance, a certain customer has his
        lunch break at your restaurant or orders for it every day of the month,
        the customers loyalty deserves to be rewarded. iRecharge perks can be
        used to generate a voucher for that customer which can be a certain % of
        the total amount the customer has spent that month and the customer can
        simply visit the iRecharge website and use the voucher to purchase
        airtime from the website. <br />
        A <strong>supermarket</strong> can generate vouchers as reward for its
        customers based on their purchase of a particular product or when their
        total bill is up to a certain amount. This is certainly an efficient
        method of increasing total sales, promoting a product and also a way to
        keep customers coming back. <br />
        <strong>Recreational centres</strong> such as bars, gymnasiums, outdoor
        facilities etc. have an existing customer base and also one-time
        customers. For instance gym members can get a free voucher if they pay
        new month membership fees before the previous month runs out. A voucher
        can be attached to the purchase of a certain drink in the bar, and
        whoever purchases the drink gets the voucher. <br />
        Use iRecharge perks to make existing customers even more loyal and give
        the one time customers a reason to come back. Surprise your customers or
        even your staff with vouchers to purchase iRecharge products based on
        whatever criteria suits your business. Tailor your reward or promotion
        system to be convenient for you and also exciting for your customers and
        clients. Use any of our templates to design your vouchers and order
        discount prints. Feel free to get creative and design your own custom
        promotions. <br />
        Contact us with the details and iRecharge will make it happen.
      </p>
    </div>
    <solution-part />
  </div>
</template>
<script>
import SolutionPart from '@/components/partials/SolutionPart.vue'
export default {
  name: 'iRechargePerks',
  components: {
    SolutionPart
  },
  mounted() {
    this.startCarousel()
  },
  data() {
    return {}
  },
  methods: {
    startCarousel() {
      var owlClients = $('#owlClients')
      owlClients.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 1000,
        autoplayHoverPause: true
      })
      var owlTestimonial = $('#owlTestimonial')
      owlTestimonial.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
      })
    }
  }
}
</script>
<style scoped>
ul li {
  list-style-type: circle;
  text-align: left;
}
.card {
  padding: 15px 20px;
}
</style>
